import { render, staticRenderFns } from "./StoredValueCard.vue?vue&type=template&id=48b3addf&"
import script from "./StoredValueCard.vue?vue&type=script&lang=js&"
export * from "./StoredValueCard.vue?vue&type=script&lang=js&"
import style0 from "./StoredValueCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StoredValueCard.vue"
export default component.exports